import { TxErc20Transfers } from './TxErc20Transfers/TxErc20Transfers';
import { TxNative } from './TxNative/TxNative';

export const EVMTransaction = () => {
  return (
    <div>
      <TxNative />
      <TxErc20Transfers />
    </div>
  );
};
